export const ROUTES = {
  MAIN_PATH: '/notifications/:topic?',
  NOTIFICATIONS: '/notifications/activity',
  NOTIFICATIONS_NEW_FEATURE: '/notifications/new-feature',
};
